import { UserRole } from 'types';

export const getPermissionValueMap = (isProject: boolean) => {
  if (isProject) {
    return {
      admin: 2,
      collaborator: 1,
      'limited-collaborator': 0,
    };
  }
  return {
    owner: 3,
    admin: 2,
    member: 1,
    viewer: 0,
  };
};

export const viewRoles = ['limited-collaborator', 'viewer'];

export const canUpdateChooser = (
  currentUser: UserRole,
  otherUser: UserRole,
  isProject: boolean,
) => {
  if (!currentUser || !otherUser) {
    return false;
  }

  const { profile, group } = currentUser;
  const { profile: otherProfile, group: otherGroup } = otherUser;

  if (!profile || viewRoles.some(r => r === group.name)) {
    return false;
  }

  // The user of pending confirm profile is null
  const notSameUser = profile.id !== otherProfile?.id;
  const permissionValueMap = getPermissionValueMap(isProject);

  const isPermissionBiggerOrEqualToOther =
    permissionValueMap[group.name] > permissionValueMap[otherGroup.name];

  return notSameUser && isPermissionBiggerOrEqualToOther;
};
